import { __decorate, __extends } from "tslib";
import { Vue, Component } from 'vue-property-decorator';

var default_1 = function (_super) {
  __extends(default_1, _super);

  function default_1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  default_1 = __decorate([Component], default_1);
  return default_1;
}(Vue);

export default default_1;